import { ADDRESS_FIELDS, PAYMENT_FIELDS } from 'constants/formFields';
import { ADDRESS_MESSAGES, REQUEST_ERRORS } from 'constants/errorMessages';
import { VALID_PHONE } from 'common/regex';

export const REQUEST_FIELD_TO_FORM_FIELD = {
  'addCreditCardNumber': { form: 'payment', formField: PAYMENT_FIELDS.CC },
  'fullName': { form: 'payment', formField: PAYMENT_FIELDS.NAME_ON_CARD },
  'mailingAddress.addressLine1': { form: 'address', formField: ADDRESS_FIELDS.ADDRESS_LINE_1 },
  'mailingAddress.addressLine2': { form: 'address', formField: ADDRESS_FIELDS.ADDRESS_LINE_2 },
  'mailingAddress.city': { form: 'address', formField: ADDRESS_FIELDS.CITY },
  'mailingAddress.countryCode': { form: 'address', formField: ADDRESS_FIELDS.COUNTRY_CODE },
  'mailingAddress.postalCode': { form: 'address', formField: ADDRESS_FIELDS.POSTAL_CODE },
  'mailingAddress.stateOrRegion': { form: 'address', formField: ADDRESS_FIELDS.STATE_OR_REGION },
  'name.fullName': { form: 'address', formField: ADDRESS_FIELDS.FULL_NAME },
  'phone.voice.primary.number': { form: 'address', formField: ADDRESS_FIELDS.PHONE_NUMBER }
};

export function getRequestFieldError(id) {
  return REQUEST_ERRORS[id] || 'Invalid';
}

export function getRequestFieldDetails(requestField) {
  return REQUEST_FIELD_TO_FORM_FIELD.hasOwnProperty(requestField)
    && REQUEST_FIELD_TO_FORM_FIELD[requestField]
    || { form: null, field: null };
}

export function pushErrorMessages(fieldKey, newAddr) {
  const newError = [];

  switch (fieldKey) {
    case ADDRESS_FIELDS.ADDRESS_LINE_1.fieldName:
    {
      const field = ADDRESS_FIELDS.ADDRESS_LINE_1.fieldName;
      if (!hasValue(newAddr, field)) {
        newError.push(ADDRESS_MESSAGES.missing_value[field]);
      }
      break;
    }
    case ADDRESS_FIELDS.ADDRESS_LINE_2.fieldName:
    {
      break;
    }
    case ADDRESS_FIELDS.CITY.fieldName:
    {
      const field = ADDRESS_FIELDS.CITY.fieldName;
      if (!hasValue(newAddr, field)) {
        newError.push(ADDRESS_MESSAGES.missing_value[field]);
      }
      break;
    }
    case ADDRESS_FIELDS.COUNTRY_CODE.fieldName:
    {
      const field = ADDRESS_FIELDS.COUNTRY_CODE.fieldName;
      if (!hasValue(newAddr, field)) {
        newError.push(ADDRESS_MESSAGES.missing_value[field]);
      }
      break;
    }
    case ADDRESS_FIELDS.FULL_NAME.fieldName:
    {
      const field = ADDRESS_FIELDS.FULL_NAME.fieldName;
      if (!hasValue(newAddr, field)) {
        newError.push(ADDRESS_MESSAGES.missing_value[field]);
      }
      break;
    }
    case ADDRESS_FIELDS.PHONE_NUMBER.fieldName:
    {
      const field = newAddr.hasOwnProperty('number') ? 'number' : ADDRESS_FIELDS.PHONE_NUMBER.fieldName;
      if (!hasValue(newAddr, field)) {
        newError.push(ADDRESS_MESSAGES.missing_value[ADDRESS_FIELDS.PHONE_NUMBER.fieldName]);
        break;
      }
      if (!validatePhone(newAddr[field])) {
        newError.push(ADDRESS_MESSAGES.invalid_phone);
        break;
      }
      break;
    }
    case ADDRESS_FIELDS.POSTAL_CODE.fieldName:
    {
      const field = ADDRESS_FIELDS.POSTAL_CODE.fieldName;
      if (!hasValue(newAddr, field)) {
        newError.push(ADDRESS_MESSAGES.missing_value[field]);
      }
      break;
    }
    case ADDRESS_FIELDS.STATE_OR_REGION.fieldName:
    {
      const field = ADDRESS_FIELDS.STATE_OR_REGION.fieldName;
      if (!hasValue(newAddr, field)) {
        const type = '_text';
        newError.push(ADDRESS_MESSAGES.missing_value[field + type]);
      }
      break;
    }
  }
  return newError;
}

export function validatePhone(num) {
  return num.match(VALID_PHONE);
}

export function hasValue(collection, field) {
  return collection.hasOwnProperty(field) && collection[field].trim().length > 0;
}
